import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray900};
`;

export const StatusBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 24px;
  background-color: ${({ theme }) => theme.colors.gray800};
`;

export const StatusLabel = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 60px 0 50px 0;
  max-height: 90vh;
  overflow: scroll;
`;

export const PicturesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  margin-top: 24px;
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.gray25};
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 0 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.gray800};
  position: relative;
  --a: 50vw;
  width: calc(var(--a) - 32px);
  min-height: calc(var(--a) * 0.75 - 24px);

  img {
    height: calc((var(--a) * 0.75) - 24px);
    border-radius: 8px;
  }
`;

export const UploadImage = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.gray900};
  font-size: 24px;
  border: none;
  border-radius: 8px;
  width: 80px;
  height: 80px;
`;

export const EditButton = styled.button`
  position: absolute;
  left: 4px;
  top: 4px;
  width: 32px;
  height: 32px;
  padding: 4px;
  background: rgba(28, 38, 49, 0.56);
  border-radius: 4px;
  border: none;
  font-size: 16px;
`;

export const ButtonIcon = styled.span`
  font-size: 24px;
`;
